import { connect } from 'react-redux'
import { branch, compose, getContext, renderNothing } from 'recompose'
import PropTypes from 'prop-types'
import { selectHasRecentLoan } from 'src/store/selectors/home'
import {
  selectRefiDetails,
  selectRefiYearsInHome,
  selectPotentialPMISavings
} from 'src/store/selectors/refinance'
import {
  setYearsInHome,
  trackRefiDetailsViewEvent
} from 'src/actions/refinance'
import { withElementRef } from 'src/composables'
import scrollToRefOnMount from 'src/composables/scrollToRefOnMount'
import withEventOnceOnMount from 'src/composables/withEventOnceOnMount'
import { ModuleShown, EVENTS_LABELS } from 'src/constants/trackingEvents'
import { RefiSection } from 'src/constants/notificationRefs'
import { selectRefiStatus } from 'src/store/selectors/home/interest'
import history from 'src/history'
import { OVERLAY_HELPERS } from 'src/constants/navigation'
import { buildKey } from 'src/Components/homeowners/RefiDetailsOverlay/RefiDetailsOverlay'

const Container = compose(
  getContext({ locked: PropTypes.bool }),
  connect(
    state => ({
      pmi: selectPotentialPMISavings(state),
      yearsInHome: selectRefiYearsInHome(state),
      refiDetails: selectRefiDetails(state),
      hasRecentLoan: selectHasRecentLoan(state),
      ...selectRefiStatus(state)
    }),
    dispatch => ({
      navRefiOption: opt => {
        const key = buildKey(opt)
        history.push(OVERLAY_HELPERS.refinance.buildPath(key))

        dispatch(trackRefiDetailsViewEvent(opt))
      },
      setYearsInHome: value => dispatch(setYearsInHome(parseInt(value, 10)))
    })
  ),
  branch(
    ({ hasRecentLoan, refiDetails }) =>
      hasRecentLoan || !refiDetails || refiDetails.length === 0, // TODO: duplicated logic in selectShouldRenderRefiOptions
    renderNothing
  ),
  withElementRef(RefiSection),
  scrollToRefOnMount,
  withEventOnceOnMount(ModuleShown, {
    eventLabel: EVENTS_LABELS.RefiScenariosSection
  })
)

export default Container
